module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hotsite-dcom', [_c('div', {
    staticClass: "conteudo"
  }, [_c('contato', {
    staticClass: "contato-dcom"
  }, [_c('p', [_c('strong', [_vm._v("FALE CONOSCO")])]), _c('ul', [_c('li', [_c('span', [_vm._v("Telefone institucional: (84) 3342-2274")])]), _c('li', [_c('span', [_vm._v("Secretaria Administrativa: ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:secretaria@dmp.ufrn.br"
    }
  }, [_vm._v("secretaria@dmp.ufrn.br")]), _vm._v(" "), _c('span', [_vm._v("/ Ramais 107 e 114")])]), _c('li', [_c('span', [_vm._v("Setor de Aquisições: ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:falecomaquisicoes@dmp.ufrn.br"
    }
  }, [_vm._v("falecomaquisicoes@dmp.ufrn.br")]), _vm._v(" "), _c('span', [_vm._v("/ Ramal: 106")])]), _c('li', [_c('span', [_vm._v("Setor de Contratações: ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:falecomcontratacoes@dmp.ufrn.br"
    }
  }, [_vm._v("falecomcontratacoes@dmp.ufrn.br")]), _vm._v(" "), _c('span', [_vm._v("/ Ramal: 119")])]), _c('li', [_c('span', [_vm._v("Setor de Licitações: ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:cpl@dmp.ufrn.br"
    }
  }, [_vm._v("cpl@dmp.ufrn.br")]), _vm._v(" "), _c('span', [_vm._v("/ Ramais: 115 e 129")])]), _c('li', [_c('span', [_vm._v("Setor de Pós-Compra: ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:poscompra@dmp.ufrn.br"
    }
  }, [_vm._v("poscompra@dmp.ufrn.br")]), _vm._v(" "), _c('span', [_vm._v("/ Ramais: 143 e 144")])]), _c('li', [_c('span', [_vm._v("Setor de Controle e Registro Contábil:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:controlepatrimonial@dmp.ufrn.br"
    }
  }, [_vm._v("controlepatrimonial@dmp.ufrn.br")]), _vm._v(" "), _c('span', [_vm._v("/ Ramal: 151")])]), _c('li', [_c('span', [_vm._v("Setor de Patrimônio:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:patrimonio.ufrn@gmail.com"
    }
  }, [_vm._v("patrimonio.ufrn@gmail.com")]), _vm._v(" "), _c('span', [_vm._v("/ Ramais: 134, 135, 136 e 137")])]), _c('li', [_c('span', [_vm._v("Seção de Importação: ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:dimport@dmp.ufrn.br"
    }
  }, [_vm._v("dimport@dmp.ufrn.br")]), _vm._v(" "), _c('span', [_vm._v("/ Ramais: 126 e 127")])]), _c('li', [_c('span', [_vm._v("Setor de Almoxarifado: ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:almoxarifadocentral@dmp.ufrn.br"
    }
  }, [_vm._v("almoxarifadocentral@dmp.ufrn.br")]), _vm._v(" "), _c('span', [_vm._v("/ Telefone: 3215-3340")])]), _c('li', [_c('span', [_vm._v("Setor de Almoxarifado de Manutenção de Obras: ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:almoxarifadonovodmp@gmail.com"
    }
  }, [_vm._v("almoxarifadonovodmp@gmail.com")]), _vm._v(" "), _c('span', [_vm._v("/ Telefone: 3342-2399 / Ramais: 220, 221 e 223")])])]), _c('p', [_vm._v("Para demais informações, dúvidas ou sugestões entre em contato através do formulário abaixo:")]), _c('formulario', {
    attrs: {
      "destino": 'dmp'
    }
  })], 1), _c('localizacao', [_c('p', [_vm._v("Texto com o endereço da unidade...")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-484e9b24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/dcom/Contato.vue
// module id = 486
// module chunks = 0